<div [class.bounce-behavior]="env.DISABLE_BOUNCE_IOS_EFFECT">
    <!-- Old webs -->
    <ng-container *ngIf="!env.USE_TAILWIND">
        <aside class="accessibility" #accessibility tabindex="-1">
            <div class="block--wrap block">
                <span class="icon icon-accessibility" role="image" alt=""></span>
                <span class="accessibility-text" role="text">{{ 'HEADER_ACCESSIBILITY_TEXT' | translate }}</span>
                <a
                    class="link link--action link--emphasized accessibility-skip-content"
                    *ngIf="!corporatePortalPage"
                    tabindex="0"
                    role="button"
                    href="{{ skipToContentPath }}">
                    {{ 'HEADER_ACCESSIBILITY_SKIP_MAIN_CONTENT_TEXT' | translate }}
                </a>

                <a
                    class="link link--action link--emphasized accessibility-contrast"
                    (click)="toggleTheme()"
                    (keydown.enter)="toggleTheme()"
                    (keydown.space)="toggleTheme()"
                    tabindex="0"
                    role="button">
                    <span *ngIf="(isContrast$ | async) === false">
                        {{ 'HEADER_ACCESSIBILITY_CONTRAST_TEXT' | translate }}
                    </span>
                    <span *ngIf="(isContrast$ | async) === true">
                        {{ 'HEADER_ACCESSIBILITY_NORMAL_CONTRAST_TEXT' | translate }}
                    </span>
                </a>
            </div>
        </aside>

        <aside
            class="absolute inset-x-0 top-0 -z-50 h-full w-full text-center focus-within:z-50 focus-within:block focus-within:bg-slate-500/50"
            *ngIf="env.USE_TAILWIND">
            <a class="btn-primary mt-6" tabindex="0" role="button" href="{{ skipToContentPath }}">{{
                'HEADER_ACCESSIBILITY_SKIP_MAIN_CONTENT_TEXT' | translate
            }}</a>
        </aside>

        <div class="site w-full" [ngClass]="{ 'focus-hidden': !showFocusOutline, 'flex flex-col': env.USE_TAILWIND }">
            <gl-header
                class="site-header"
                *ngIf="!corporatePortalPage"
                [selected]="selectedLang"
                [isLandingPage]="isLandingPage"
                (requestLanguageChange)="changeLanguage($event)"
                (highContrastToggle)="toggleTheme()"></gl-header>
            <main>
                <router-outlet></router-outlet>
            </main>
            <gl-footer class="site-footer" *ngIf="!corporatePortalPage"></gl-footer>
        </div>
        <rwidget-cookie-notification #cookie></rwidget-cookie-notification>
    </ng-container>

    <!-- STW webs -->
    <ng-container *ngIf="env.USE_TAILWIND && !env.IS_MOBILE_APP">
        <ng-container *ngIf="isPdfPrintingNotInProgress$ | async; else webApplicationContent">
            <ion-app [ngClass]="{ 'focus-hidden': !showFocusOutline }">
                <ion-content class="h-screen overflow-x-hidden" [scrollEvents]="true" (ionScroll)="handleScrollStart()">
                    <div cdkScrollable>
                        <ng-container [ngTemplateOutlet]="webApplicationContent"></ng-container>
                    </div>
                    <rwidget-cookie-notification #cookie></rwidget-cookie-notification>
                </ion-content>
            </ion-app>
        </ng-container>
    </ng-container>

    <!-- Apps -->
    <ng-container *ngIf="env.USE_TAILWIND && env.IS_MOBILE_APP">
        <ion-app [ngClass]="{ 'focus-hidden': !showFocusOutline, 'safe-top': displaySafeTop }">
            <rwidget-alert [target]="'global-modal'"></rwidget-alert>
            <ion-content
                #ionContentRef
                [class.refresh-bounce]="isPullToRefreshEnabled$ | async"
                [scrollEvents]="true"
                (ionScroll)="handleScrollStart()"
                cdkScrollable>
                <main class="flex h-full [&>ng-component]:min-w-full" role="none">
                    <ion-refresher
                        *ngIf="isPullToRefreshEnabled$ | async"
                        (ionRefresh)="handleRefresh($event)"
                        slot="fixed">
                        <ion-refresher-content></ion-refresher-content>
                    </ion-refresher>
                    <router-outlet *ngIf="splashScreenRemoved"></router-outlet>
                </main>
            </ion-content>
            <ion-footer
                class="z-50"
                *ngIf="splashScreenRemoved"
                [ngStyle]="{ display: keyboardOpen ? 'none' : 'block' }">
                <ng-container *ngIf="appFooterStatus === appFooterType.navigation && !isFooterHidden">
                    <gl-footer-app
                        (languageChange)="changeLanguage($event)"
                        (highContrastToggle)="toggleTheme()"></gl-footer-app>
                </ng-container>
            </ion-footer>
            <ridango-modal
                [size]="'800'"
                [visible]="termsModalVisible$ | async"
                [isItSmall]="false"
                [outsideClickAllowed]="false"
                (onCloseModal)="onTermsAgreement(false)">
                <ridango-terms-modal-content [termsUrl]="termsUrl" (onAgree)="onTermsAgreement($event)">
                </ridango-terms-modal-content>
            </ridango-modal>
        </ion-app>
    </ng-container>
</div>

<ng-template #webApplicationContent>
    <div class="flex min-h-screen flex-col">
        <div
            class="flex w-full max-w-[100vw] grow flex-col"
            id="printPdfApp"
            [ngClass]="{ 'min-h-screen': exploreOrJPPage }">
            <gl-header
                class="site-header sticky top-0 z-40 w-full bg-[var(--color-primary-header)] pt-[env(safe-area-inset-top)] md:relative"
                [selected]="selectedLang"
                [isLandingPage]="isLandingPage"
                (requestLanguageChange)="changeLanguage($event)"
                (highContrastToggle)="toggleTheme()"></gl-header>
            <main
                class="flex grow flex-col overflow-hidden [&>ng-component]:flex [&>ng-component]:grow [&>ng-component]:flex-col">
                <router-outlet></router-outlet>
            </main>
        </div>
        <gl-footer class="site-footer hu-light-dark:lg:!h-[361px]"></gl-footer>
    </div>
</ng-template>
